import numeral from "numeral";

export const percentage = (partial: number, total: number): string => {
  return numeral(partial / total).format("0.0%");
};
